import { Component, OnInit } from '@angular/core'
import { environment } from '@candidate/environments/environment'
@Component({
  selector: 'app-about',
  templateUrl: './about.component.html',
  styleUrls: ['./about.component.scss'],
})
export class AboutComponent implements OnInit {
  candidateEnv = environment
  constructor() {}

  ngOnInit(): void {}
}
